import { isBlank } from 'helpers/string_helpers';
import { createSelector } from 'reselect';

export const getCurrentPage = state => state.query.page;
export const getPageSize = state => state.query.pageSize;
export const getSelectedInvestmentTypes = state => state.query.investmentTypes;
export const getSelectedTransactionTypes = state => state.query.transactionTypes;
export const getSelectedPropertyTypes = state => state.query.propertyTypes;
export const getSearchText = state => state.query.searchText;
export const getSort = state => state.query.sort;
export const getAddressFilter = state => state.query.addressFilter;
export const getPropertyFilter = state => state.query.propertyFilter;

export const noFiltersApplied = (state) => {
  const query = state.query;

  const investmentTypes = query.investmentTypes || [];
  const transactionTypes = query.transactionTypes || [];
  const propertyTypes = query.propertyTypes || [];

  const addressFilterEmpty = Object.keys(query.addressFilter).every((key) => {
    if (key === "cities") return query.addressFilter[key].length === 0;
    return isBlank(query.addressFilter[key]);
  });

  const propertyFilterEmpty = Object.keys(query.propertyFilter).every((key) => {
    if (key === "sizeUnits") return true;
    return isBlank(query.propertyFilter[key]);
  });

  const filtersAreEmpty = addressFilterEmpty && propertyFilterEmpty;
  const nothingIsSelected = transactionTypes.length === 0 && propertyTypes.length === 0 && investmentTypes.length === 0;

  return filtersAreEmpty && nothingIsSelected && isBlank(query.searchText);
};

export const filtersApplied = createSelector(
  [noFiltersApplied],
  noFiltersApplied => !noFiltersApplied
);
